import { render, staticRenderFns } from "./PersonalityHighsAndLowsCard.vue?vue&type=template&id=4527096e&"
import script from "./PersonalityHighsAndLowsCard.vue?vue&type=script&lang=js&"
export * from "./PersonalityHighsAndLowsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports